import React from 'react';

import { type GetColorF, type GetLabelColorF, StepWrapper, StepUnderline, StepLabelWrapper, Counter } from './styled.ts';

type StepProps = {
  id: string;
  stepNumber: number;
  title: string;
  onClick?: () => void;
};

type CreateStepComponentArg = {
  getLabelColor: GetLabelColorF;
  getColor: GetColorF;
  underline?: boolean;
  componentName: string;
  disabled?: boolean;
};
const createStepComponent = ({ getLabelColor, getColor, underline, componentName, disabled = false }: CreateStepComponentArg) => {
  const Step = React.memo(function Step({ id, stepNumber, title, onClick }: StepProps) {
    return (
      <StepWrapper onClick={!disabled ? onClick : undefined} disabled={disabled}>
        <StepLabelWrapper $getLabelColor={getLabelColor} data-testid={`${id.toLowerCase()}-step`}>
          <Counter $getColor={getColor}>{stepNumber}</Counter>
          {title}
        </StepLabelWrapper>
        {underline ? <StepUnderline $getColor={getColor} /> : null}
      </StepWrapper>
    );
  });

  Step.displayName = componentName;
  return Step;
};

export const Step = {
  Complete: createStepComponent({
    getLabelColor: ({ theme, hover }) => (hover ? theme.colors.black_1 : theme.colors.grey100_1),
    getColor: ({ theme }) => theme.colors.grey100_1,
    componentName: 'CompleteStep',
  }),
  Current: createStepComponent({
    getLabelColor: ({ theme, hover }) => (hover ? theme.colors.blackDark_1 : theme.colors.black_1),
    getColor: ({ theme }) => theme.colors.main,
    componentName: 'CurrentStep',
    underline: true,
  }),
  NextStep: createStepComponent({
    getLabelColor: ({ theme, hover }) => (hover ? theme.colors.grey100_1 : theme.colors.grey70_1),
    getColor: ({ theme }) => theme.colors.grey70_1,
    componentName: 'NextStep',
  }),
  Disabled: createStepComponent({
    getLabelColor: ({ theme, hover }) => (hover ? theme.colors.grey100_1 : theme.colors.grey70_1),
    getColor: ({ theme }) => theme.colors.grey30_1,
    componentName: 'DisabledStep',
    disabled: true,
  }),
} as const;
